import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, retry } from 'rxjs';

import { Common } from '../shared/common';
import { Constants } from './constant';

@Injectable()
export class AuthService {
  static _forgotPasswordEmail: string = '';
  static _otpSent: boolean = false;

  constructor(private http: HttpClient) { }

  login(username: string, password: string) {
    return this.http.post(Constants.getApiEndpoint() + '/auth/login', JSON.stringify({
      username,
      password
    }), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  resetPassword(email: string) {
    const params = { 'email': email };
    return this.http.post<any>((Constants.getApiEndpoint() + '/auth/forgot-password'), params);
  }


  register(username: string, email: string, password: string): Observable<any> {
    return this.http.post(Constants.getApiEndpoint() + 'signup', {
      username,
      email,
      password
    }, Common.httpOptions);
  }

  verifyFPOTP(request: any) {
    return this.http.post<any>((Constants.getApiEndpoint() + `/auth/verify-forgot-password-otp`), request)
  }

  public set verificationforgotPasswordEmail(email: any) {
    AuthService._forgotPasswordEmail = email;
  }

  public get verificationforgotPasswordEmail(): any {
    return AuthService._forgotPasswordEmail;
  }

  public get isOTPSent() {
    return AuthService._otpSent;
  }

  public set isOTPSent(otpSent: boolean) {
    AuthService._otpSent = otpSent;
  }
}
